/**
 * Erbil landing page (SEO-ready template)
 * - Provides page meta, FAQ and LocalBusiness JSON-LD template for local landing.
 * - This file is a template and does not modify routes; wire it into routing if/when needed.
 */

import React from 'react'
import Seo from '../../components/Seo'
import FAQList from '../../components/faq/FAQList'

/**
 * Erbil landing page component
 */
export default function ErbilLanding(): JSX.Element {
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Does Edicoo have an office in Erbil?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes — Edicoo operates from Erbil and provides local support and on-the-ground media services in the Erbil region.'
        }
      },
      {
        '@type': 'Question',
        name: 'What services can Edicoo deliver locally in Erbil?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Local campaign management, media planning & buying, influencer coordination and content production tailored for Erbil audiences.'
        }
      }
    ]
  }

  const localBusinessJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Edicoo Agency — Erbil',
    url: 'https://your-site.com/landings/erbil',
    telephone: '+964 750 413 2323',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Baharke Road, Next to Majesty School',
      addressLocality: 'Erbil',
      addressRegion: 'Kurdistan',
      addressCountry: 'IQ'
    },
    openingHours: 'Mo,Tu,We,Th,Fr 09:00-18:00',
    sameAs: [
      'https://www.linkedin.com/company/edicoo',
      'https://www.facebook.com/edicoo',
      'https://www.instagram.com/edicoo'
    ]
  }

  // Map JSON-LD structure into UI-friendly items
  const faqItems = (faqJsonLd.mainEntity || []).map((m: any) => ({
    question: m.name || '',
    answer: (m.acceptedAnswer && (m.acceptedAnswer.text || '')) || ''
  }))

  return (
    <>
      <Seo
        title="Edicoo in Erbil — Local Advertising & Digital Marketing"
        description="Local Edicoo office in Erbil providing media planning, digital marketing, influencer partnerships and creative services tailored to Erbil audiences."
        url="https://your-site.com/landings/erbil"
        image="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/f2dcbeba-4716-4434-8b8b-01acce34f085.png"
        jsonLd={[faqJsonLd, localBusinessJsonLd]}
      />

      <main className="max-w-4xl mx-auto py-20 px-4">
        <h1 className="text-4xl font-bold mb-4">Edicoo — Erbil</h1>
        <p className="text-lg text-gray-700">
          Local media planning, digital campaigns, influencer coordination and creative production for Erbil businesses and brands.
        </p>
      </main>

      {/* Visible FAQ section (non-intrusive, matches injected JSON-LD) */}
      <FAQList items={faqItems} />
    </>
  )
}